import axios from "axios";

const uploadAxios = axios.create({
  withCredentials: false,
});

const API_URL = process.env.REACT_APP_API_URL;

uploadAxios.interceptors.request.use((config) => {
  delete config.headers.Authorization;
  return config;
});

export const finishMultipartUpload = async (data) => {
  axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("session_token")}`;
  return axios.post(`${API_URL}/datasets/v2/complete_multipart_upload/`, data);
};

export const splitFileIntoChunks = (file, chunkSize) => {
  const chunks = [];
  let start = 0;

  while (start < file.size) {
    const end = Math.min(start + chunkSize, file.size);
    const chunk = file.slice(start, end);
    chunks.push(chunk);
    start = end;
  }

  return chunks;
};

//const uploadChunk = async (chunk, chunkIndex, presignedUrl) => {
//  try {
//    const response = await uploadAxios.put(presignedUrl, chunk);

//    return response.data;
//  } catch (error) {
//    console.error(`Error uploading chunk ${chunkIndex}:`, error);
//    throw error;
//  }
//};

export const uploadDatasetFile = async (file, presignedUrl, fileExtension) => {
  try {
    const response = await uploadAxios.put(presignedUrl, file, {
      headers: {
        "Content-Type": fileExtension,
      },
    });

    return response;
  } catch (error) {
    console.error("Error uploading file with presigned URL:", error);
    console.error("Presigned URL:", presignedUrl);
    throw error;
  }
};

export const handleLargeFileUpload = async ({
  presignedUrls = [],
  chunks = [],
  uploadId,
  key,
  fileExtension,
}) => {
  try {
    const parts = [];
    let currentChunkIndex = 0;

    const processChunk = async () => {
      if (currentChunkIndex >= chunks.length) {
        console.log("All chunks uploaded successfully:", parts);

        await finishMultipartUpload({
          parts,
          upload_id: uploadId,
          key,
        });

        return parts;
      }

      const chunk = chunks[currentChunkIndex];
      const presignedUrl = presignedUrls[currentChunkIndex];

      try {
        const result = await uploadDatasetFile(chunk, presignedUrl, fileExtension);
        parts.push({
          part_number: currentChunkIndex + 1,
          e_tag: result?.headers?.etag || result?.headers?.ETag || "",
        });

        //if (onChunkComplete) {
        //  onChunkComplete(currentChunkIndex, chunks.length);
        //}

        currentChunkIndex++;

        return await processChunk();
      } catch (error) {
        console.error(`Error uploading chunk ${currentChunkIndex + 1}:`, error);
        throw error;
      }
    };

    await processChunk();
  } catch (error) {
    console.error("Error initiating multipart upload:", error);
  }
};
